// LEGACY: Uses SCSS with CSS modules. New code should use @metarouter-private/mr-mui components instead.
// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';
import pt from 'prop-types';
import { Button, Stack } from '@metarouter-private/mr-mui';
import { BulkExportLauncher } from '../bulk-export';

import s from './index.module.scss';

const Header = ({ cluster, earliestSeen, timeframeHours, reports, resetReports }) => {
  const title = () => {
    if (!cluster) {
      return null;
    }
    return (
      <div className={s.clusterTitle}>
        {' '}
        Schema Report for {cluster.name} (Last {timeframeHours} hours)
      </div>
    );
  };

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
      {title()}
      <Stack direction="row" spacing={1}>
        <BulkExportLauncher cluster={cluster} earliestSeen={earliestSeen} reports={reports} />
        <Button className={s.report} size="large" onClick={() => resetReports()}>
          New Report
        </Button>
      </Stack>
    </Stack>
  );
};

Header.propTypes = {
  cluster: pt.shape({
    name: pt.string,
  }),
  earliestSeen: pt.string,
  timeframeHours: pt.number,
  reports: pt.array,
  resetReports: pt.func.isRequired,
};

export default Header;
